import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { colDefs, DebitNoteEntryTable, rowData, table2ColDefs, table2Data } from "./DebitNoteEntryTable";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { isValidForm } from "../../../utils/validation/CommonValidator.js";
import { CommonValidationMessages } from "../../../utils/Messages.js";
import moment from "moment";
import { decryptAES } from "../../../utils/Encryption.js";
import { Navigate } from "react-router-dom";
import { permission } from "../../../utils/enums/ValidationMessage.js";

class DebitNoteEntry extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            urlId: 0,
            prop: {},
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            rowData: [],
            colDefs: [],
            idDebitNote: 0,
            idUser: 0,
            idCompany: 0,
            debitNoteDetails: {
                idDebitNote: 0,
                updateStatus: 0,
                debitNoteNo: "",
                date: "",
                partyAccount: "",
                particulars: "",
                purchaseNo: "",
                refNo: "",
                amount: "",
                // taxType: "",
                // tax: "",
                // sgst: "",
                // cgst: "",
                // igst: "",
                tcsPercentage: "",
                tcsAmt: "",
                finalAmt: "",
                remarks: "",

                partyList: [],
                mainPartyList: [],
                idPartyAccount: 0,
                partyACName: "",
                taxtTypeList: [
                    {
                        id: 1,
                        name: 'INTRASTATE'
                    },
                    {
                        id: 2,
                        name: 'INTERSTATE'
                    }
                ],
                idTaxtType: 1,
                taxtTypeName: "INTRASTATE",
                taxtStructureList: [],
                mainTaxtStructureList: [],
                idTaxStructure: 0,
                taxStructureName: "",
                sgst: "",
                cgst: "",
                igst: "",
                sgstAmt: "",
                cgstAmt: "",
                igstAmt: "",
                e_Date: "",
                e_IdUser: 0,
                updatedDate: "",
                idFinancialYear: 0,
                idMaterialInward: 0,
                inwardNo: "",
                purchaseNoList: [],
                mainPurchaseNoList: [],
                particularsList: [],
                mainParticularsListList: [],
                particularsId: "",
                particularsName: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                idPartyAccount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "party account"
                        ),
                    },
                ],
                // particularsId: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "particulars"
                //         ),
                //     },
                // ],
                // idMaterialInward: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "purchase no"
                //         ),
                //     },
                // ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                idTaxtType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "tax type"
                        ),
                    },
                ],
                idTaxStructure: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "tax"
                        ),
                    },
                ],
                // sgst: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "sgst"
                //         ),
                //     },
                // ],
                // cgst: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "cgst"
                //         ),
                //     },
                // ],
                // igst: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "igst"
                //         ),
                //     },
                // ],
                // tcsPercentage: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "TCS percentage"
                //         ),
                //     },
                // ],
                // tcsAmt: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "TCS amount"
                //         ),
                //     },
                // ],
                // finalAmt: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "final amount"
                //         ),
                //     },
                // ],
            },
        };
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Debit Note Entry");
        //}
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }


        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect();
                this.usp_Master_GeneralProductSelect();
            });
        } else {
            // window.location.href = "/Login";
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };


    usp_Master_GeneralProductSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let debitNoteDetail = this.state.debitNoteDetails;
                data = data.map((x) => ({
                    id: x.idGeneralProduct,
                    name: x.productName,
                }));
                debitNoteDetail.particularsList = data;
                debitNoteDetail.mainParticularsListList = data;
                this.setState({
                    debitNoteDetails: debitNoteDetail
                });
            }
        });
    }

    submitDebitNote = () => {
        if (this.isSubmitting) { return; }
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let data = this.state.debitNoteDetails;
            let request = {
                idDebitNote: data.idDebitNote,
                updateStatus: data.updateStatus,
                debitNoteNo: data.debitNoteNo,
                date: data.date,
                particulars: data.particularsName,
                particularsId: data.particularsId,
                idPartyAccount: data.idPartyAccount,
                refNo: data.refNo,
                amount: Number(data.amount) > 0 ? Number(data.amount).toFixed(2) : 0,
                debitType: data.taxtTypeName,
                idTaxGroup: data.idTaxStructure,
                cgstAmt: Number(data.cgstAmt) > 0 ? Number(data.cgstAmt).toFixed(2) : 0,
                sgstAmt: Number(data.sgstAmt) > 0 ? Number(data.sgstAmt).toFixed(2) : 0,
                //igstAmt: data.igstAmt,
                igst: data.igstAmt > 0 ? data.igst : 0,
                igstAmt: Number(data.igstAmt) > 0 ? Number(data.igstAmt).toFixed(2) : 0,
                tcsPercentage: data.tcsPercentage,
                tcsAmount: Number(data.tcsAmt) > 0 ? Number(data.tcsAmt).toFixed(2) : 0,
                finalAmt: Number(data.finalAmt) > 0 ? Math.round(data.finalAmt) : 0,
                remarks: data.remarks,
                //idMaterialInward : data. ,
                idCompany: this.state.idCompany,
                e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                e_IdUser: data.e_IdUser ? data.e_IdUser : this.state.idUser,
                isUpdated: data.updateStatus === 1 ? this.state.idUser : data.updateStatus,
                updatedDate: data.updateStatus === 1 ? new Date().toISOString() : data.updatedDate,
                u_IdUser: data.updateStatus === 1 ? this.state.idUser : 0,
                isDeleted: false,
                deletedDate: null,
                d_IdUser: null,
                idFinancialYear: data.idFinancialYear,
                idMaterialInward: data.idMaterialInward,
            };
            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.accountTransactionServices.submitDebitNote(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    if (data !== null) {
                        if (this.state.debitNoteDetails.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.setState({
                                isModalOpen: false,
                                //receiptDetails: reset
                            }, () => {
                                this.resetFields();
                                this.procSelectAllRecordsSP();
                            });
                        }
                    }
                }
            }).finally(() => {
                this.isSubmitting = false;
                this.setState({ isSaving: false });
            });
            // } else {
            //     console.log(this.state.debitNoteDetails)
            //     console.log(this.state.validState.error)
            // }
            // this.setState({ isModalOpen: !this.state.isModalOpen });
        }
    }

    getDebitNoteSelectById = (id) => {
        this.accountTransactionServices.getDebitNoteSelectById(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let responseData = response.responseItem.responseContent[0];

                this.accountTransactionServices.getPurchaseInwardSelectbyIDPartyFor_DebitNote({ idCompany: responseData.idCompany, idPartyAccount: responseData.idPartyAccount }).then((response) => {
                    //debugger;
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        let Detail = this.state.debitNoteDetails;
                        if (data.length > 0) {
                            data = data.map((x) => ({ id: x.idMaterialInward, name: x.inwardNo, }));
                        }
                        Detail.purchaseNoList = data;
                        this.setState({
                            debitNoteDetails: Detail
                        }, () => {
                            this.accountTransactionServices.getTaxStructureSelectbyID(responseData.idTaxGroup).then((response) => {
                                if (response.statusCode == 200 && response.responseItem !== null) {
                                    let res = response.responseItem.responseContent[0];
                                    let debitNoteDetail = this.state.debitNoteDetails;
                                    debitNoteDetail.sgst = res.sgst;
                                    debitNoteDetail.cgst = res.cgst;
                                    debitNoteDetail.igst = res.igst;
                                    debitNoteDetail.idDebitNote = responseData.idDebitNote;
                                    debitNoteDetail.updateStatus = 1;
                                    debitNoteDetail.debitNoteNo = responseData.debitNoteNo;
                                    debitNoteDetail.date = moment(responseData.date).format('YYYY-MM-DD');
                                    debitNoteDetail.particularsId = responseData.particularsId;
                                    debitNoteDetail.particularsName = responseData.particularsId > 0 ? debitNoteDetail.mainParticularsListList.find(item => item.id === responseData.particularsId)?.name : "";
                                    debitNoteDetail.refNo = responseData.refNo;
                                    debitNoteDetail.amount = responseData.amount;
                                    debitNoteDetail.tcsPercentage = responseData.tcsPercentage;
                                    debitNoteDetail.tcsAmt = responseData.tcsAmount;
                                    debitNoteDetail.finalAmt = responseData.finalAmount;
                                    debitNoteDetail.remarks = responseData.remarks;
                                    debitNoteDetail.idPartyAccount = responseData.idPartyAccount;
                                    debitNoteDetail.partyACName = responseData.idPartyAccount ? debitNoteDetail.partyList.find(item => item.id === responseData.idPartyAccount)?.name ? debitNoteDetail.partyList.find(item => item.id === responseData.idPartyAccount)?.name : "" : "";
                                    debitNoteDetail.taxtTypeName = responseData.debitType;
                                    debitNoteDetail.idTaxtType = debitNoteDetail.taxtTypeList.find(item => item.name === responseData.debitType)?.id;
                                    debitNoteDetail.idTaxStructure = responseData.idTaxGroup;
                                    debitNoteDetail.taxStructureName = debitNoteDetail.mainTaxtStructureList.find(item => item.id === responseData.idTaxGroup)?.name;
                                    debitNoteDetail.sgstAmt = responseData.sgstAmt;
                                    debitNoteDetail.cgstAmt = responseData.cgstAmt;
                                    debitNoteDetail.igstAmt = responseData.igstAmt;
                                    debitNoteDetail.e_Date = responseData.e_Date;
                                    debitNoteDetail.idFinancialYear = responseData.idFinancialYear;
                                    debitNoteDetail.idMaterialInward = responseData.idMaterialInward;
                                    debitNoteDetail.inwardNo = debitNoteDetail.mainPurchaseNoList.find(item => item.id === responseData.idMaterialInward)?.name;
                                    this.setState({
                                        debitNoteDetails: debitNoteDetail, isModalOpen: true
                                    });
                                }
                            });
                        });
                    }
                });

            } else {
                //this.usp_Master_GeneralProductSelect();
            }
        });
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        id: x.idPartyAccount,
                        name: x.partyACName,
                    }));

                    let detail = this.state.debitNoteDetails;
                    detail.partyList = dynamicData;
                    detail.mainPartyList = dynamicData;
                    this.setState({
                        debitNoteDetails: detail
                    }, () => {
                        this.getTaxStructure();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getTaxStructure();
                }
            }
        });
    }


    getTaxStructure = () => {
        this.accountTransactionServices.getTaxStructure(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                res = res.map((x) => ({
                    id: x.idTaxStructure,
                    name: x.taxStructureName,
                }));
                let debitNoteDetail = this.state.debitNoteDetails;
                debitNoteDetail.taxtStructureList = res;
                debitNoteDetail.mainTaxtStructureList = res;
                this.setState({
                    debitNoteDetails: debitNoteDetail
                }, () => {
                })
            }
        });
    }

    getTaxStructureSelectbyID = (id) => {
        this.accountTransactionServices.getTaxStructureSelectbyID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                //debugger;
                let data = this.state.debitNoteDetails;
                data.sgst = res.sgst;
                data.cgst = res.cgst;
                data.igst = res.igst;
                this.setState({ debitNoteDetails: data }, () => {
                    this.calculatePricing()
                });
            }
        });
    }

    getPurchaseInwardSelectbyIDPartyFor_DebitNote = (idCompany, id) => {
        let request = {
            idCompany: idCompany,
            idPartyAccount: id
        }
        this.accountTransactionServices.getPurchaseInwardSelectbyIDPartyFor_DebitNote(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let Detail = this.state.debitNoteDetails;
                if (data.length > 0) {
                    data = data.map((x) => ({
                        id: x.idMaterialInward,
                        name: x.inwardNo,
                    }));
                    Detail.idMaterialInward = 0;
                    Detail.inwardNo = "";
                    Detail.purchaseNoList = data;
                    Detail.mainPurchaseNoList = data;
                } else {
                    Detail.purchaseNoList = [];
                }

                this.setState({
                    debitNoteDetails: Detail
                });
            }
        });
    }

    getDebitNoteCount = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 0
        };
        this.accountTransactionServices.getDebitNoteCount(request).then((response) => {
            //debugger;
            if (response.statusCode == 200 && response.responseItem !== null) {
                let list = this.state.rowData;
                let maxIdPaymentMake = list.length > 0
                    ? Math.max(...list.map(item => item.idDebitNote))
                    : 0;
                let creditNoteNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                let data = this.state.debitNoteDetails;
                data.debitNoteNo = creditNoteNo;
                this.setState({
                    debitNoteDetails: data
                });
            } else {
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Debit Note Entry",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            minWidth: this.getColumnWidth(key),
                            hide: ["sR.No", "idDebitNote"].includes(key) ? true : false,
                            valueFormatter: key.includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        //debugger
                        data.map((x) => {
                            x.date = moment(x.date).format('YYYY-MM-DD');
                        });
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Debit Note Entry",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Debit Note Entry");
                            this.getDebitNoteCount();
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        }, () => {
                            if (this.gridApi) {
                                this.gridApi.hideOverlay();
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        this.setState({ idCreditNote: id }, () => {
            this.getDebitNoteSelectById(this.state.idCreditNote);
        });
    };

    getColumnWidth = (key) => {
        const columnWidths = {
            "debitNoteNo": window.innerWidth * 0.04,
            "date": window.innerWidth * 0.07,
            "partyACName": window.innerWidth * 0.25,
            "inwardNo": window.innerWidth * 0.04,
            "invoiceNo": window.innerWidth * 0.04,
            "amount": window.innerWidth * 0.04,
            "finalAmount": window.innerWidth * 0.05,
            "status": window.innerWidth * 0.07,
            "debit From": window.innerWidth * 0.1,
        };
        return columnWidths[key];
    };

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    resetFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let reset = this.state.debitNoteDetails;
        reset.idCreditNote = 0;
        reset.updateStatus = 0;
        reset.debitNoteNo = "";
        reset.date = "";
        reset.particulars = "";
        reset.refNo = "";
        reset.amount = "";
        reset.cbitNoteType = "";
        reset.tax = "";
        reset.tcsPercentage = "";
        reset.tcsAmt = "";
        reset.finalAmt = "";
        reset.remarks = "";
        reset.idPartyAccount = 0;
        reset.partyACName = "";
        reset.idTaxtType = 1;
        reset.taxtTypeName = "INTRASTATE";
        reset.idTaxStructure = 0;
        reset.taxStructureName = "";
        reset.sgst = "";
        reset.cgst = "";
        reset.igst = "";
        reset.sgstAmt = "";
        reset.cgstAmt = "";
        reset.igstAmt = "";
        reset.e_Date = "";
        reset.e_IdUser = 0;
        reset.updatedDate = "";
        reset.idFinancialYear = 0;
        reset.idMaterialInward = 0;
        reset.inwardNo = "";
        reset.particularsId = 0;
        reset.particularsName = "";
        this.setState({ debitNoteDetails: reset, validState: validState })
    }

    calculatePricing = () => {
        let debitNoteDetail = this.state.debitNoteDetails;
        if (debitNoteDetail.amount > 0) {
            debitNoteDetail.sgstAmt = debitNoteDetail.taxtTypeName === "INTRASTATE" ? Number(debitNoteDetail.amount) * Number(debitNoteDetail.sgst) / 100 : 0;
            debitNoteDetail.cgstAmt = debitNoteDetail.taxtTypeName === "INTRASTATE" ? Number(debitNoteDetail.amount) * Number(debitNoteDetail.cgst) / 100 : 0;
            debitNoteDetail.igstAmt = debitNoteDetail.taxtTypeName === "INTRASTATE" ? 0 : Number(debitNoteDetail.amount) * Number(debitNoteDetail.igst) / 100;
            debitNoteDetail.finalAmt = Math.round((Number(debitNoteDetail.amount) + Number(debitNoteDetail.sgstAmt) + Number(debitNoteDetail.cgstAmt) + Number(debitNoteDetail.igstAmt))).toFixed(2);

            if (debitNoteDetail.tcsPercentage > 0) {
                debitNoteDetail.tcsAmt = Number(debitNoteDetail.finalAmt) * Number(debitNoteDetail.tcsPercentage) / 100;
                debitNoteDetail.finalAmt = Math.round(Number(debitNoteDetail.finalAmt) + Number(debitNoteDetail.tcsAmt));
            } else {
                debitNoteDetail.tcsAmt = 0
            }
            this.setState({
                debitNoteDetails: debitNoteDetail
            })
        } else {
            debitNoteDetail.sgstAmt = 0;
            debitNoteDetail.cgstAmt = 0;
            debitNoteDetail.igstAmt = 0;

            debitNoteDetail.netTotal = 0;
            debitNoteDetail.tcsAmt = 0;
            debitNoteDetail.finalAmt = 0;

            this.setState({
                debitNoteDetails: debitNoteDetail
            })
        }
    }

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ idDebitNote: event.data.idDebitNote, validState: validState }, () => {
            this.getDebitNoteSelectById(this.state.idDebitNote);
        });
        //this.openPopUpForUpdateItem(event);
    };

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetFields();
        this.setState({ isModalOpen: true }, () => {
            this.getDebitNoteCount();
        })
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.debitNoteDetails;
        details[name] = value;
        this.setState({ debitNoteDetails: details }, () => {
            if (name === 'amount' || name === 'tcsPercentage') {
                this.calculatePricing();
            }
        });
    }
    handleSelectChange = (event, name) => {
        let data = this.state.debitNoteDetails;
        if (name === 'partyList') {
            //debugger
            let arr = this.state.debitNoteDetails.mainPartyList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.debitNoteDetails;
            data.partyACName = value;
            data.partyList = found;
        } else if (name === "TaxtStructureList") {
            // debugger
            let arr = this.state.debitNoteDetails.mainTaxtStructureList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.debitNoteDetails;
            data.taxStructureName = value;
            data.taxtStructureList = found;
        } else if (name === "purchaseNoList") {
            // debugger
            let arr = this.state.debitNoteDetails.mainPurchaseNoList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.debitNoteDetails;
            data.inwardNo = value;
            data.purchaseNoList = found;
        } else if (name === "particulars") {
            // debugger
            let arr = this.state.debitNoteDetails.mainParticularsListList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.debitNoteDetails;
            data.particularsName = value;
            data.particularsList = found;
        }
        this.setState({ debitNoteDetails: data });
    }

    setFilterParameters = (id, name, drpIdentity) => {
        //debugger
        let data = this.state.debitNoteDetails;
        if (drpIdentity === 'partyList') {
            data.idPartyAccount = id;
            data.partyACName = name;
        }

        if (drpIdentity === 'FromAccount') {
            data.idBank = id;
            data.bankName = name;
            // data.idChequeBookMaster = 0;
            // data.chequeBookSeries = "";
            // data.seriesList = [];
            // data.idChequeBookDetails = 0;
            // data.chequeNo = "";
            // data.chequeNoList = [];
        }
        if (drpIdentity === 'TaxtStructureList') {
            data.idTaxStructure = id;
            data.taxStructureName = name;
        }
        if (drpIdentity === 'Type') {
            data.fromAccountTypeId = id;
            data.fromAccountTypeName = name;
        }
        if (drpIdentity === 'NoteType') {
            data.idTaxtType = id;
            data.taxtTypeName = name;
        }
        if (drpIdentity === 'purchaseNoList') {
            data.idMaterialInward = id;
            data.inwardNo = name;
        }
        if (drpIdentity === 'particulars') {
            data.particularsId = id;
            data.particularsName = name;
        }
        this.setState({ debitNoteDetails: data }, () => {
            if (drpIdentity === 'TaxtStructureList') {
                this.getTaxStructureSelectbyID(id);
            }
            if (drpIdentity === 'partyList') {
                this.getPurchaseInwardSelectbyIDPartyFor_DebitNote(this.state.idCompany, id);
            }
        });
    };

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    // saveItem = () => {
    //     const isValidAllFields = this.isValidAllFields();
    //     if (isValidAllFields) {
    //         let details = this.state.debitNoteDetails;
    //         if (details !== "") {

    //             console.log(details);
    //         } else {
    //             console.log("Enter valid data")
    //         }
    //     } else {
    //         console.log(this.state.debitNoteDetails)
    //         console.log(this.state.validState.error)
    //     }
    //     // this.setState({ isModalOpen: !this.state.isModalOpen });

    // }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.debitNoteDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='debit-note-entry'>
                <div className="data-display">
                    <div className="data-display-inner relative">
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: this.handleSave,
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <DebitNoteEntryTable
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            handleSelectChange={this.handleSelectChange.bind(this)}
                            debitNoteDetails={this.state.debitNoteDetails}
                            validState={this.state.validState}
                            submitDebitNote={this.submitDebitNote.bind(this)}
                            isSaving={this.state.isSaving}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            close={this.closePopup.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Debit note entry</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                        {/* <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={table2Data}
                                    columnDefs={table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.state.onGridReady}
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default DebitNoteEntry;